<template>
  <div class="container" id="goods-edit">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <el-breadcrumb separator="">
        <el-breadcrumb-item>
          <div class="div1">订单管理</div>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <div class="div2">物流订单</div>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <h2>母订单拆单</h2>
      <div style="display:flex;justify-content:space-between">
        <div style="line-height:36px">订单商品
          <span style="color: #4168E7;margin-left: 12px;font-size: 14px;">订单编号（2212061630285747）</span>
          <span style="color: #4168E7;margin-left: 12px;font-size: 14px;">代收金额￥{{ totalAmount }}</span>
        </div>
        <div class="aBtn" @click="add">增加拆单</div>
      </div>
      <el-table border :data="goods" :header-cell-style="{
        background: '#F5F6FA',

        color: '#303033',
      }" style="width: 100%;margin-top:20px;">
        <el-table-column label="商品" prop="type" align="left">
          <template slot="header">
            <div style="display: flex">
              <div style="text-align: left">商品</div>
            </div>
          </template>
          <template slot-scope="props">
            <div style="display:flex">
              <div><img style="width:106px;height:80px" :src="props.row.img" /></div>
              <div>
                <div
                  style="margin-left:8px;font-size: 14px;font-family: PingFang SC;font-weight: bold;line-height: 22px;color: #333333;">
                  {{ props.row.name }}</div>
              </div>

            </div>

          </template>
        </el-table-column>
        <el-table-column label="商品规格" prop="type" align="center">
          <template slot-scope="props">
            <div style="text-align: center">{{ props.row.sku }}</div>
          </template>
        </el-table-column>
        <el-table-column label="数量" prop="type" align="center">
          <template slot-scope="props">
            <div style="text-align: center">x{{ props.row.num }}</div>
          </template>
        </el-table-column>
        <el-table-column label="拆单已选" prop="type" align="center">
          <template slot-scope="props">
            <div style="text-align: center">{{ props.row.yNum }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div v-for="(item, index) in splitData" :key="index" style="margin-top:10px">
        <div style="display:flex;justify-content:space-between">
          <div style="display: flex;">
            <div
              style="width: 16px;height: 16px;background: #4168E7;border-radius: 50%;opacity: 1;font-size: 14px;font-family: PingFang SC;font-weight: 400;line-height: 16px;color: #FFFFFF;text-align: center;margin-top: 12px;">
              {{ index + 1 }}</div>
            <div style="line-height: 40px;margin-left: 2px;">拆单订单{{ index + 1 }}</div>
            <div style="line-height: 40px;margin-left: 2px;color: #4168E7;font-size: 14px;">母订单编号：2212061630285747X{{
              index
              + 1 }}</div>
          </div>

          <div style="display: flex;">
            <div style="margin-left: 12px;margin-top: 4px;"><el-button @click="deleteOrder(index)"
                style="color:red;border: 1px solid red;width:90px;height: 28px;line-height: 10px;margin-top: 2px;" plain
                size="small">删除</el-button>
            </div>
          </div>
        </div>

        <el-table border :data="item.tableData" :header-cell-style="{
          background: '#FAFAFA',

          color: '#303033',
        }" style="width: 100%;margin-top: 10px;">
          <el-table-column label="商品" prop="type" align="left">
            <template slot="header">
              <div style="display: flex">
                <div style="text-align: left">商品</div>
              </div>
            </template>
            <template slot-scope="props">
              <div style="display:flex;width:100%">
                <div><img style="width:106px;height:80px" :src="props.row.img" /></div>
                <div style="margin-left:12px;flex:1">
                  <div>
                    <el-input type="textarea" :rows="3" v-model="props.row.name" style="height: 80px;"></el-input>
                    <!-- <div style="text-align: left;line-height: 20px;margin-top: 5px;">规格101</div> -->
                  </div>

                </div>
              </div>

            </template>
          </el-table-column>
          <el-table-column label="商品规格" prop="type" align="center">
            <template slot-scope="props">
              <div style="text-align: center">{{ props.row.sku }}</div>
            </template>
          </el-table-column>
          <el-table-column label="数量" prop="type" align="center">
            <template slot-scope="props">
              <div style="text-align: center"><el-input v-model="props.row.num" style="width:224px" size="small"
                  @change="upDateNum($event, index, props.$index, props.row)" placeholder="请输入数量"></el-input></div>
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="type" align="center">
            <!-- <template slot="header">
              <div style="display: flex">
                <div style="text-align: center">操作 </div>
              </div>
            </template> -->
            <template slot-scope="props">
              <div style="color:#4168E7" @click="deleteD(index, props.$index)">
                删除
              </div>

            </template>
          </el-table-column>
        </el-table>
        <div class="aBtn" style="margin-top: 16px;" @click="addShop(index)">增加商品</div>
      </div>
      <div style="height: 20px;"></div>
    </div>
    <div style="display: flex;justify-content: start;margin-top: 20px;margin-bottom: 20px;padding-bottom:20px">
      <div class="cBtn1" @click="back">取消</div>
      <div class="qBtn" @click="submit()">确认</div>
    </div>
    <el-dialog title="选择商品" :visible.sync="dialogTableVisible" append-to-body width="640px">
      <div style="padding:20px 30px">
        <el-table border :data="selectGoods" :header-cell-style="{
          background: '#FAFAFA',

          color: '#303033',
        }" style="width: 100%;margin-top: 10px;">
          <el-table-column label="商品名称" prop="type" align="left">
            <template slot="header">
              <div style="display: flex">
                <div style="text-align: left">商品名称</div>
              </div>
            </template>
            <template slot-scope="props">
              <div>{{ props.row.name }}</div>
            </template>
          </el-table-column>
          <el-table-column label="商品规格" prop="type" align="center">
            <template slot-scope="props">
              <div style="text-align: center">{{ props.row.sku }}</div>
            </template>
          </el-table-column>
          <el-table-column label="剩余数量" prop="type" align="center">
            <template slot-scope="props">
              {{ props.row.num }}
            </template>
          </el-table-column>
          <el-table-column label="选择拆单数量" prop="type" align="center">
            <template slot-scope="props">
              <div style="text-align: center"><el-input v-model="props.row.yNum" style="width:100%" size="small"
                  @change="inputNum($event, props.$index, props.row)" placeholder="请输入数量"></el-input></div>
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="type" align="center">
            <template slot-scope="props">
              <el-checkbox v-model="props.row.checked"></el-checkbox>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="width:100%;height: 0px;border: 1px solid #D9D9D9;"></div>
      <div style="display: flex;justify-content: end;margin-top: 20px;margin-bottom: 10px;margin-right: 30px;">
        <div class="cBtn" @click="dialogTableVisible = false">取消</div>
        <div class="qBtn" @click="save()">确定</div>
      </div>

    </el-dialog>
    <el-dialog title="温馨提示" :visible.sync="isFinish" width="30%" :append-to-body="true">
      <div slot="title" class="dialog-title">
        <i class="el-icon-warning" style="font-size: 22px;color:orange"></i>
        <span
          style="font-size: 18px;font-family: PingFang SC;font-weight: bold;line-height: 30px;color: #333333;margin-left: 12px;">温馨提示</span>
      </div>
      <div class="content" style="padding:20px 30px">
        <div style="font-size: 16px;margin-top: 20px;margin-left: 30px;" v-if="isContent">订单未完成拆单，请继续拆单！</div>
        <div style="font-size: 16px;margin-top: 20px;margin-left: 30px;" v-if="!isContent">拆单订单填写的<span
            style="color:red">[代收金额]</span>总和不等于原订单，请修改填写!</div>
        <div style="display: flex;justify-content: end;margin-top: 20px;margin-bottom: 10px;">
          <div class="cBtn" @click="isFinish = false">取消</div>
          <div class="qBtn" @click="isFinish = false">确定</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="删除拆单" :visible.sync="isDelete" width="30%" :append-to-body="true">
      <div slot="title" class="dialog-title">
        <i class="el-icon-warning" style="font-size: 22px;color:orange"></i>
        <span
          style="font-size: 18px;font-family: PingFang SC;font-weight: bold;line-height: 30px;color: #333333;margin-left: 12px;">删除拆单</span>
      </div>
      <div class="content" style="padding:20px 30px">
        <div style="font-size: 16px;margin-top: 20px;margin-left: 30px;">是否确认删除<span style="color:red">[订单拆单]{{ this.index
        }}</span>，删除后不可恢复数据!</div>
        <div style="display: flex;justify-content: end;margin-top: 20px;margin-bottom: 10px;">
          <div class="cBtn" @click="isDelete = false">取消</div>
          <div class="qBtn" @click="cDeleterOrder()">确定</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import headerPicture from '@/components/upload/headerPicture.vue'
export default {
  components: {
    headerPicture
  },
  data() {
    return {
      totalAmount: 800,
      isContent: true,
      isDelete: false,
      value: true,
      checked1: true,
      isFinish: false,
      index: 0,
      dIndex: 0,
      dialogTableVisible: false,
      name: '---',
      qrCodeUrl: '',
      contact: '',
      dialogUser: false,
      splitData: [
        //  {
        //   tableData:[]
        //  }
      ],
      selectGoods: [
        {
          id: '1',
          img: 'https://fenxiao.muruji.com/internalSystem/aeeeab5d-7f12-4b69-8351-0825e98acd4c',
          name: '测试类目1212',
          num: 10,
          yNum: 0,
          sku: '250g/饼',
          checked: false,
        },
        {
          id: '2',
          img: 'https://fenxiao.muruji.com/internalSystem/aeeeab5d-7f12-4b69-8351-0825e98acd4c',
          name: '测试类目1123',
          num: 12,
          yNum: 0,
          sku: '250g/饼',
          checked: false,
        },
        {
          id: '3',
          img: 'https://fenxiao.muruji.com/internalSystem/aeeeab5d-7f12-4b69-8351-0825e98acd4c',
          name: '测试类目123',
          num: 14,
          yNum: 0,
          sku: '250g/饼',
          checked: false,
        },
        {
          id: '4',
          img: 'https://fenxiao.muruji.com/internalSystem/aeeeab5d-7f12-4b69-8351-0825e98acd4c',
          name: '测试类目11222',
          num: 19,
          yNum: 0,
          sku: '250g/饼',
          checked: false,
        }
      ],
      goods: [
        {
          id: '1',
          img: 'https://fenxiao.muruji.com/internalSystem/aeeeab5d-7f12-4b69-8351-0825e98acd4c',
          name: '测试类目1212',
          num: 10,
          yNum: 0,
          sku: '250g/饼'
        },
        {
          id: '2',
          img: 'https://fenxiao.muruji.com/internalSystem/aeeeab5d-7f12-4b69-8351-0825e98acd4c',
          name: '测试类目1123',
          num: 12,
          yNum: 0,
          sku: '250g/饼'
        },
        {
          id: '3',
          img: 'https://fenxiao.muruji.com/internalSystem/aeeeab5d-7f12-4b69-8351-0825e98acd4c',
          name: '测试类目123',
          num: 14,
          yNum: 0,
          sku: '250g/饼'
        },
        {
          id: '4',
          img: 'https://fenxiao.muruji.com/internalSystem/aeeeab5d-7f12-4b69-8351-0825e98acd4c',
          name: '测试类目11222',
          num: 19,
          yNum: 0,
          sku: '250g/饼'
        }
      ],
      goodsCopy: [
        {
          id: '1',
          img: 'https://fenxiao.muruji.com/internalSystem/aeeeab5d-7f12-4b69-8351-0825e98acd4c',
          name: '测试类目1212',
          num: 10,
          yNum: 0,
          sku: '250g/饼'
        },
        {
          id: '2',
          img: 'https://fenxiao.muruji.com/internalSystem/aeeeab5d-7f12-4b69-8351-0825e98acd4c',
          name: '测试类目1123',
          num: 12,
          yNum: 0,
          sku: '250g/饼'
        },
        {
          id: '3',
          img: 'https://fenxiao.muruji.com/internalSystem/aeeeab5d-7f12-4b69-8351-0825e98acd4c',
          name: '测试类目123',
          num: 14,
          yNum: 0,
          sku: '250g/饼'
        },
        {
          id: '4',
          img: 'https://fenxiao.muruji.com/internalSystem/aeeeab5d-7f12-4b69-8351-0825e98acd4c',
          name: '测试类目11222',
          num: 19,
          yNum: 0,
          sku: '250g/饼'
        }
      ],
      selectGoodsCopy: [
        {
          id: '1',
          img: 'https://fenxiao.muruji.com/internalSystem/aeeeab5d-7f12-4b69-8351-0825e98acd4c',
          name: '测试类目1212',
          num: 10,
          yNum: 0,
          sku: '250g/饼',
          checked: false,
        },
        {
          id: '2',
          img: 'https://fenxiao.muruji.com/internalSystem/aeeeab5d-7f12-4b69-8351-0825e98acd4c',
          name: '测试类目1123',
          num: 12,
          yNum: 0,
          sku: '250g/饼',
          checked: false,
        },
        {
          id: '3',
          img: 'https://fenxiao.muruji.com/internalSystem/aeeeab5d-7f12-4b69-8351-0825e98acd4c',
          name: '测试类目123',
          num: 14,
          yNum: 0,
          sku: '250g/饼',
          checked: false,
        },
        {
          id: '4',
          img: 'https://fenxiao.muruji.com/internalSystem/aeeeab5d-7f12-4b69-8351-0825e98acd4c',
          name: '测试类目11222',
          num: 19,
          yNum: 0,
          sku: '250g/饼',
          checked: false,
        }
      ]
    }
  },
  created() {

  },
  methods: {
    cDeleterOrder() {
      this.splitData.splice(this.dIndex, 1)
      let tempArray = []
      for (let i = 0; i < this.splitData.length; i++) {
        this.splitData[i].tableData.forEach(item => {
          item.num = Number(item.num)
          tempArray.push(item)
        })
      }
      console.log(tempArray)
      if (tempArray.length != 0) {
        let setArr = this.concatData(JSON.parse(JSON.stringify(tempArray)))
        this.goods.forEach(item => {
          setArr.forEach(item1 => {
            if (item.id == item1.id) {
              item.yNum = item1.num
            } else {
              item.yNum = 0
            }
          })
        })
      } else {
        this.goods = this.goodsCopy
      }

      this.isDelete = false
    },
    deleteOrder(index) {
      this.isDelete = true
      this.dIndex = index
    },
    upDateNum(e, index, sIndex, row) {
      console.log(e)
      this.splitData[index].tableData[sIndex].num = e
      let tempArray = []
      for (let i = 0; i < this.splitData.length; i++) {
        this.splitData[i].tableData.forEach(item => {
          item.num = Number(item.num)
          tempArray.push(item)
        })
      }
      console.log(tempArray)
      let setArr = this.concatData(JSON.parse(JSON.stringify(tempArray)))
      setArr.forEach(item => {
        this.goods.forEach(item1 => {
          if (item.id == item1.id && item.num > item1.num) {
            this.$message({
              type: 'error',
              message: '数量不能大于剩余量'
            })
            this.splitData[index].tableData[sIndex].num = 0
          }
        })

      })
      this.goods.forEach(item => {
        setArr.forEach(item1 => {
          if (item.id == item1.id) {
            item.yNum = item1.num
          }
        })
      })
      console.log(tempArray)
    },
    inputNum(e, index, row) {
      console.log(e)
      if (e > row.num) {
        this.$message({
          type: 'error',
          message: '数量不能大于剩余量'
        })
        this.selectGoods[index].yNum = null
      }
    },
    deleteD(index, dIndex) {
      this.splitData[index].tableData.splice(dIndex, 1)
      let tempArray = []
      for (let i = 0; i < this.splitData.length; i++) {
        this.splitData[i].tableData.forEach(item => {
          item.num = Number(item.num)
          tempArray.push(item)
        })
      }
      console.log(tempArray)
      if (tempArray.length != 0) {
        let setArr = this.concatData(JSON.parse(JSON.stringify(tempArray)))
        this.goods.forEach(item => {
          setArr.forEach(item1 => {
            if (item.id == item1.id) {
              item.yNum = item1.num
            } else {
              item.yNum = 0
            }
          })
        })
      } else {
        this.goods = this.goodsCopy
      }
    },
    add() {
      let obj = {
        money: 0,
        tableData: []
      }
      this.splitData.push(obj)
    },
    //合并数组
    concatData(oldArr) {
      var temp = {};
      for (var i in oldArr) {
        var id = oldArr[i].id;
        if (temp[id]) {
          temp[id].num += oldArr[i].num;
        } else {
          temp[id] = oldArr[i]
        }
      }
      var newArr = [];
      for (var j in temp) {
        newArr.push(temp[j])
      }
      return newArr;
    },
    //处理数据
    handleData() {
      let tempArray = []
      for (let i = 0; i < this.splitData.length; i++) {
        this.splitData[i].tableData.forEach(item => {
          item.num = Number(item.num)
          tempArray.push(item)
        })
      }
      console.log(tempArray)
      let setArr = this.concatData(JSON.parse(JSON.stringify(tempArray)))
      for (let i = 0; i < setArr.length; i++) {
        this.selectGoods.forEach(item => {
          if (item.id == setArr[i].id) {
            console.log(item.num)
            item.num = item.num - setArr[i].num
          }
        })
      }
      console.log(this.selectGoods)
      this.selectGoods = this.selectGoods.filter(val => val.num > 0);
    },
    addShop(index) {
      console.log(index)
      this.dialogTableVisible = true
      this.index = index
      this.selectGoods = JSON.parse(JSON.stringify(this.selectGoodsCopy))
      this.selectGoods.forEach(item => {
        item.checked = false
        item.yNum = 0
      })
      console.log(this.splitData, this.selectGoods)
      if (this.splitData[this.index].tableData.length == 0) {
        this.handleData()

      } else {
        this.splitData[this.index].tableData.forEach(item => {
          this.selectGoods = this.selectGoods.filter(val => val.id != item.id && val.num != 0);
        })
      }
    },
    save() {
      this.selectGoods.forEach(item => {
        if (item.checked) {
          console.log(item)
          let obj = {
            id: item.id,
            img: item.img,
            name: item.name,
            sku: item.sku,
            num: item.yNum,
          }
          this.splitData[this.index].tableData.push(obj)
        }
      })
      let tempArray = []
      for (let i = 0; i < this.splitData.length; i++) {
        this.splitData[i].tableData.forEach(item => {
          item.num = Number(item.num)
          tempArray.push(item)
        })
      }
      console.log(tempArray)
      let setArr = this.concatData(JSON.parse(JSON.stringify(tempArray)))
      this.goods.forEach(item => {
        setArr.forEach(item1 => {
          if (item.id == item1.id) {
            item.yNum = item1.num
          }
        })
      })
      this.dialogTableVisible = false

    },
    back() {
      this.$router.go(-1)
    },
    submit() {
      let goodsCount = 0
      let cGoodsCount = 0
      let totalAmount = 0
      this.goods.forEach(item => {
        if (item.num) {
          goodsCount += item.num
        }
      })
      this.splitData.forEach(item => {
        item.tableData.forEach(item1 => {
          cGoodsCount += item1.num
        })
        totalAmount += item.money
      })
      if (goodsCount != cGoodsCount) {
        this.isFinish = true
        this.isContent = true
      } else if (goodsCount == cGoodsCount && totalAmount != this.totalAmount) {
        this.isFinish = true
        this.isContent = false
      } else {
        // let data = {
        //   name: this.name,
        //   contact: this.contact,
        //   qrCodeUrl: this.qrCodeUrl
        // }
        // this.$api.editCustomerServiceConfig(data).then(res => {
        //   if (res.code == 0) {
        //     this.$message({
        //       type: 'success',
        //       message: '更改成功'
        //     });
        //     this.getConfig()
        //   }
        // })
      }


    }
  }
}
</script>
<style scoped>
::v-deep .el-dialog__body {
  padding: 0;
}

.splitType {
  width: 120px;
  height: 24px;
  background: #E3EDFF;
  opacity: 1;
  border-radius: 18px;
  line-height: 24px;
  text-align: center;
  color: #333333;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  margin-top: 8px;
  margin-left: 24px;
}

::v-deep .el-textarea__inner {
  padding: 7px 15px !important;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4168E7;
  border-color: #4168E7;
}

::v-deep .el-switch__core {
  width: 58px !important;
}

::v-deep .el-switch__label {
  position: absolute;
  /* display: none; */
  color: #fff;
}

/*打开时文字位置设置*/
::v-deep .el-switch__label--left {
  z-index: 1;
  right: 14px;
}

.cBtn1 {
  width: 120px;
  height: 36px;
  border: 1px solid #D9D9D9;
  opacity: 1;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: #FFFFFF;
  text-align: center;
  cursor: pointer;
  margin-right: 12px;
  background: #CCCCCC;
}

.cBtn {
  width: 120px;
  height: 36px;
  border: 1px solid #D9D9D9;
  opacity: 1;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: #999999;
  text-align: center;
  cursor: pointer;
  margin-right: 12px;
}

.qBtn {
  width: 120px;
  height: 36px;
  background: #4168E7;
  opacity: 1;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: #FFFFFF;
  text-align: center;
  cursor: pointer;
}

.goodsItem {
  width: 600px;
  height: 84px;
  background: #ecf0fd;

  display: flex;
  margin-bottom: 16px;
}

.goodsItem-name {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #333333;
}

.goodsItem-sku {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 20px;
  color: #666666;
}

.aBtn {
  width: 120px;
  height: 36px;
  background: #4168E7;
  opacity: 1;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: #FFFFFF;
  text-align: center;
  cursor: pointer;
}

.div1 {
  margin-left: -16px;
  background: url(../../assets/breadcrumb2.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2d7edf;
}

.div2 {
  margin-left: -16px;
  background: url(../../assets/breadcrumb1.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}

.dialog-search {
  display: flex;
  width: 46%;
  justify-content: space-between;
  margin-top: 10px;
  margin-left: 10px;
}
</style>
  
  